import { TapResponseFrame, TapRequestFrame } from '@iotize/tap/client/api';
import {
  HostProtocol,
  TargetProtocol,
  VariableFormat,
  AppPathType,
  SpecialFeature,
  TapVersion,
} from '@iotize/tap';

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface SlaveServerRawConfig {
  channel: SlaveServerRawConfig.Channel;
  length: number;
  config: Uint8Array;
}

export namespace SlaveServerRawConfig {
  /* tslint:disable */
  /**
   * This file was automatically generated by json-schema-to-typescript.
   * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
   * and run json-schema-to-typescript to regenerate this file.
   */

  export enum Channel {
    DISABLED = 0,
    MODBUS_RTU = 1,
    SPI = 2,
    CAN = 3,
    MODBUS_TCP = 4,
  }
}
